import { render, staticRenderFns } from "./deliveryAddress.vue?vue&type=template&id=617b97af&scoped=true"
import script from "./deliveryAddress.vue?vue&type=script&lang=js"
export * from "./deliveryAddress.vue?vue&type=script&lang=js"
import style0 from "./deliveryAddress.vue?vue&type=style&index=0&id=617b97af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617b97af",
  null
  
)

export default component.exports